import combineReducers from 'redux/lib/combineReducers';

import user from './user';

export default combineReducers({
  user,
});
